import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function CirclePlusIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 21 21" htmlColor={Color.PrimaryMain} {...props}>
      <path d="M13.614 10.007h-2.5v-2.47a.7.7 0 0 0-.719-.687.7.7 0 0 0-.687.719v2.469h-2.47a.7.7 0 0 0-.687.719.7.7 0 0 0 .719.687h2.469v2.469a.7.7 0 0 0 .718.687.7.7 0 0 0 .688-.718v-2.47h2.469a.7.7 0 0 0 .687-.718.694.694 0 0 0-.687-.688Z" />
      <path d="M10.426 1.288A9.43 9.43 0 0 0 .99 10.725c0 5.219 4.25 9.469 9.468 9.469 5.22 0 9.47-4.25 9.47-9.469-.032-5.219-4.282-9.437-9.5-9.437Zm0 17.5c-4.437 0-8.031-3.625-8.031-8.063a8.03 8.03 0 0 1 8.031-8.031c4.438 0 8.063 3.594 8.063 8.031s-3.625 8.063-8.063 8.063" />
    </MuiSvgIcon>
  );
}
export default CirclePlusIcon;
